import type { Locale } from '../types';

export const ensureLeadingSlash = (path: string) => (path.startsWith('/') ? path : `/${path}`);
export const ensureLocalePrefix = (path: string, locale: Locale) => {
  const prefix = locale === 'en-US' ? '' : path.startsWith(`/${locale}`) ? '' : `/${locale}`;
  return `${prefix}${ensureLeadingSlash(path)}`;
};
